import { SxProps, Theme } from '@mui/material';

export const orderItemTableItemDetailsMiniSX: Record<string, SxProps<Theme>> = {
	container: {
		gap: '10px',
		p: '10px',
		width: '100%',
	},
	details: {
		gap: '10px',
		width: '100%',
	},
	name: {
		color: 'grey.500',
		display: '-webkit-box',
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		maxHeight: '36px',
		whiteSpace: 'normal',
	},
	sku: {
		color: 'grey.200',
	},
	image: {
		maxWidth: '90px',
		maxHeight: '90px',
	},
};

export const orderItemTableItemDetailsMiniPriceSX = (isMobile = false): SxProps<Theme> => ({
	gap: '5px',
	py: '5px',
	alignSelf: 'end',
	height: isMobile ? 'auto' : '40px',
});
